module.exports = __webpack_public_path__ + "media/assets/images/sparkles-43c09a65be8ece382b329919da0e3240.svg";